import { Box, Button, Chip, Hidden, makeStyles, Typography } from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import StarOutlineOutlinedIcon from "@material-ui/icons/StarOutlineOutlined";
import { useEffect, useState } from "react";
import { THEME_MODE } from "src/config/constants";
import { addFavoriteToken, getFavoriteTokens, removeFavoriteToken } from "src/services/favoriteToken";

const useStyle = makeStyles((theme) => ({
  tokenName: {
    fontSize: "32px",
    fontWeight: 500,
    marginRight: "1rem",
  },
  chip: {
    margin: "0.5rem 0.5rem 0rem 0rem",
    color: theme.palette.text.secondary,
    background: theme.palette.type === THEME_MODE.DARK ? "#233345" : "#D7DFEC",
    padding: "0.5rem 0.25rem",
    borderRadius: "6px",
  },
}));

export default function SubTokenTitle({ tokenId, tokenName, tokenCategories, ...props }) {
  const cls = useStyle();
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const favoriteTokens = getFavoriteTokens();
    if (favoriteTokens.includes(tokenId)) setIsFavorite(true);
  }, []);

  const onFavoriteClick = () => {
    if (isFavorite) {
      removeFavoriteToken(tokenId);
      setIsFavorite(false);
    } else {
      addFavoriteToken(tokenId);
      setIsFavorite(true);
    }
  };

  return (
    <Box {...props}>
      <Box display="flex" justifyContent="flex-start" alignItems="center" mb={2}>
        <Typography className={cls.tokenName}>{tokenName}</Typography>
        <Button color="primary" variant="outlined" onClick={() => onFavoriteClick()} style={{ height: "35px" }}>
          {isFavorite ? <StarIcon /> : <StarOutlineOutlinedIcon />}
          <Hidden smDown>{isFavorite ? "Remove from favorites" : "Add to favorites"}</Hidden>
        </Button>
      </Box>
      <Box mb={5}>
        {tokenCategories?.map((item, idx) => (
          <Chip key={idx} label={item} size="small" className={cls.chip} />
        ))}
      </Box>
    </Box>
  );
}
